import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextEditorComponent),
    multi: true
  }]
})
export class TextEditorComponent implements OnInit, ControlValueAccessor {
  editorConfig = {
    menubar: 'edit insert view format table tools',
    min_height: 300,
    branding: false,
    valid_children: '+body[style]',
    plugins: 'link lists paste spellchecker table wordcount code image',
    toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link ',
  }

  /**
   * Holds the current value of the slider
   */
  value = '';

  htmlMode = false;

  /**
   * Invoked when the model has been changed
   */
  onChange: (_: any) => void = (_: any) => { };

  /**
   * Invoked when the model has been touched
   */
  onTouched: () => void = () => { };

  constructor() { }

  ngOnInit() { }

  /**
   * Method that is invoked on an update of a model.
   */
  updateChanges() {
    this.onChange(this.value);
  }

  toggleHtmlMode(event) {
    event.preventDefault();

    this.htmlMode = !this.htmlMode;
  }

  ///////////////
  // OVERRIDES //
  ///////////////

  /**
   * Writes a new item to the element.
   * @param value the value
   */
  writeValue(value: string) {
    this.value = value;
    this.updateChanges();
  }

  /**
   * Registers a callback function that should be called when the control's value changes in the UI.
   * @param fn callback
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * Registers a callback function that should be called when the control receives a blur event.
   * @param fn callback
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
